/**
 * BFG CRM Verziókezelés
 * 
 * Auto-generated by deploy-dev.sh
 * Build time: 20260930-185833
 * Commit: 76d7fa0
 */
export const VERSION = {
  major: 0,
  minor: 87,
  patch: 1241,
  buildTime: '20260930-185833',
  commitHash: '76d7fa0',
  branch: 'development' as 'main' | 'development',
  
  get full(): string {
    const base = `${this.major}.${this.minor}.${this.patch}`;
    const suffix = '-dev';
    return `${base}${suffix}+${this.buildTime} (${this.commitHash})`;
  },
  
  get short(): string {
    return `${this.major}.${this.minor}.${this.patch}`;
  },
  
  get branchName(): string {
    return 'Development';
  }
};
